module.exports = __webpack_public_path__ + "static/forza-d01e21db3f7f207dd72cbb7d667253b0.png";